import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c08f57c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "homecontainer" }
const _hoisted_2 = { class: "title wow animate__backInDown" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "title wow animate__backInDown" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "title wow animate__backInDown" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import BannerView from '@/components/homeView/BannerView.vue'
import SecondView from '@/components/homeView/SecondView.vue'
import ThirdView from '@/components/homeView/ThirdView.vue'
import FourthView from '@/components/homeView/FourthView.vue'
import FifthView from '@/components/homeView/FifthView.vue'
import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      justify: "space-evenly",
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24
        }, {
          default: _withCtx(() => [
            _createVNode(BannerView, { id: "home" }),
            _createVNode(SecondView),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('SubTceh')), 1),
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Tech Innovative')), 1),
              _hoisted_3
            ]),
            _createVNode(ThirdView),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('SubPro')), 1),
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Pro Center')), 1),
              _hoisted_5
            ]),
            _createVNode(FourthView),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('SubHonor')), 1),
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Com Honor')), 1),
              _hoisted_7
            ]),
            _createVNode(FifthView)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})